import { render } from "./ProjectModal.vue?vue&type=template&id=4ae64ad1&scoped=true"
import script from "./ProjectModal.vue?vue&type=script&lang=js"
export * from "./ProjectModal.vue?vue&type=script&lang=js"

import "./ProjectModal.vue?vue&type=style&index=0&id=4ae64ad1&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae64ad1"]])

export default __exports__